import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.timers.js";
// import ButtonBasic from '@/components/form/ButtonBasic.vue';
// import ToggleComponent from '@/components/form/ToggleComponent.vue';
//   import { ref } from 'vue';
var CryptoJS = require("crypto-js");
import axios from 'axios';
export default {
  name: 'UserLoginBlue',
  components: {
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< UserRegistrationPurple mounted >>>>>>>>>');
    this.$store.commit('updateHideBluetoothController', true);
  },
  methods: {
    checkProfileComplete: function checkProfileComplete() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var axios, data, config, response, galleryAvatar, i, _galleryAvatar, _i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (localStorage.getItem("security")) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              axios = require("axios");
              data = {
                token: localStorage.getItem("security"),
                stage: "checkProfileComplete",
                billingPlatform: _this.$store.state.billingPlatform
              };
              config = {
                method: "post",
                url: "".concat(_this.$store.state.systemRoute, "/profile"),
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                data: data
              };
              _context.next = 7;
              return axios(config);
            case 7:
              response = _context.sent;
              console.log("app.vue profile response", response);
              if (!(response && response.data)) {
                _context.next = 58;
                break;
              }
              if (response.data.tester === true) {
                _this.$store.commit('updateTestingAccount', true);
              }
              if (response.data.unlimited === true) {
                _this.$store.commit('updateProMembership', true);
              }
              if (response.data.subscription === 'pro_membership') {
                _this.$store.commit('updateProMembership', true);
              }
              if (response.data.uid) {
                console.log('we have UID');
                _this.$store.commit("updateUserUID", response.data.uid);
              }
              if (!(response.data.valid === false)) {
                _context.next = 19;
                break;
              }
              localStorage.removeItem("security");
              localStorage.clear();
              // reload page
              location.reload();
              return _context.abrupt("return");
            case 19:
              if (!(response.data.profileCompleted === false)) {
                _context.next = 41;
                break;
              }
              setTimeout(function () {
                _this.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);

              // we have an avatar already so set it
              if (!response.data.avatar) {
                _context.next = 33;
                break;
              }
              console.log("setting avatar");
              _this.$store.commit("updateAvatar", response.data.avatar);
              i = 0;
            case 25:
              if (!(i < _this.$store.state.avatarList.length)) {
                _context.next = 32;
                break;
              }
              if (!(_this.$store.state.avatarList[i].name.toLowerCase() === response.data.avatar.toLowerCase())) {
                _context.next = 29;
                break;
              }
              galleryAvatar = _this.$store.state.avatarList[i];
              return _context.abrupt("break", 32);
            case 29:
              i++;
              _context.next = 25;
              break;
            case 32:
              if (galleryAvatar) {
                _this.$store.commit('updateSelectedGalleryAvatar', galleryAvatar);
              }
            case 33:
              if (response.data.customer_gender) {
                _this.$store.commit("updateCustomerGender", response.data.customer_gender);
              }
              if (response.data.selected_gender) {
                _this.$store.commit("updateCompanionPreference", response.data.selected_gender);
              }
              if (response.data.selected_personality) {
                _this.$store.commit("updateCustomerSelectedProfile", response.data.selected_personality);
              }
              if (response.data.selected_voice) {
                _this.$store.commit("updateCustomerSelectedVoice", response.data.selected_voice);
              }
              _this.$store.commit("updateAppExpectations", {
                romantic: response.data.romantic || false,
                tool: response.data.tool || false,
                assistant: response.data.assistant || false,
                code: response.data.code || false,
                information: response.data.information || false
              });
              _this.$store.commit("updateProfileStep", response.data.stepsCompleted);

              //  this.$store.commit('updateProfileStep', 2);
              // this.$store.commit('updateProfileStep', 6);
              // this.showProfileButton = true;
              // this.processProfileStep();
              _context.next = 56;
              break;
            case 41:
              setTimeout(function () {
                _this.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);
              // profile is completed
              if (!response.data.avatar) {
                _context.next = 54;
                break;
              }
              console.log("setting avatar");
              _this.$store.commit("updateAvatar", response.data.avatar);
              _i = 0;
            case 46:
              if (!(_i < _this.$store.state.avatarList.length)) {
                _context.next = 53;
                break;
              }
              if (!(_this.$store.state.avatarList[_i].name.toLowerCase() === response.data.avatar.toLowerCase())) {
                _context.next = 50;
                break;
              }
              _galleryAvatar = _this.$store.state.avatarList[_i];
              return _context.abrupt("break", 53);
            case 50:
              _i++;
              _context.next = 46;
              break;
            case 53:
              if (_galleryAvatar) {
                _this.$store.commit('updateSelectedGalleryAvatar', _galleryAvatar);
              }
            case 54:
              _this.$store.commit("updateProfileCompleted", true);
              _this.$store.commit("updateProfileCompletedAlmost", true);
            case 56:
              _context.next = 59;
              break;
            case 58:
              setTimeout(function () {
                _this.$store.commit("updateShowMainEntryLoader", false);
              }, 1500);
            case 59:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    userLogin: function userLogin() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var email, password, encryptedData, data, config, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this2.email.length < 4;
              if (_context2.t0) {
                _context2.next = 5;
                break;
              }
              _context2.next = 4;
              return _this2.validateEmailFormat();
            case 4:
              _context2.t0 = !_context2.sent;
            case 5:
              if (!_context2.t0) {
                _context2.next = 8;
                break;
              }
              _this2.message = 'Please enter a valid email address';
              return _context2.abrupt("return");
            case 8:
              _context2.prev = 8;
              _this2.showLoader = true;
              _this2.message = '';
              email = _this2.email;
              _this2.$store.commit('updateUserEmail', email);
              password = _this2.password;
              _context2.next = 16;
              return _this2.encryptDetailsForTransit(email, password);
            case 16:
              encryptedData = _context2.sent;
              console.log('intransitEmail', encryptedData.intransitEmail);
              console.log('intransitPassword', encryptedData.intransitPassword);
              data = {
                'password': encryptedData.intransitPassword,
                'email': encryptedData.intransitEmail
              };
              config = {
                method: 'post',
                url: "".concat(_this2.$store.state.systemRoute, "/userLogin"),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context2.prev = 21;
              _context2.next = 24;
              return axios(config);
            case 24:
              response = _context2.sent;
              _context2.next = 32;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t1 = _context2["catch"](21);
              console.log('error', _context2.t1);
              _this2.showLoader = false;
              _this2.message = 'Check username or password and try again';
            case 32:
              console.log('response', response);
              _this2.showLoader = false;
              if (response && response.data && response.data.success && response.data.token) {
                _this2.storeToken(response.data.token);
                // should be good to do stuff now 
                // this.checkMembership();
                _this2.checkProfileComplete();
                _this2.$store.commit('updateLoginDetected', true);
                _this2.$store.commit('hideBlueLogin');
                _this2.$store.dispatch('getProfile');
              } else {
                if (response && response.message) {
                  _this2.message = response.message;
                }
              }
              _context2.next = 42;
              break;
            case 37:
              _context2.prev = 37;
              _context2.t2 = _context2["catch"](8);
              console.log('error', _context2.t2);
              _this2.showLoader = false;
              if (_context2.t2 && _context2.t2.response && _context2.t2.response.data && _context2.t2.response.data.message) {
                _this2.message = _context2.t2.response.data.message;
              }
            case 42:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[8, 37], [21, 27]]);
      }))();
    },
    storageAvailable: function storageAvailable(type) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var storage, x;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              storage = window[type];
              x = '__storage_test__';
              storage.setItem(x, x);
              storage.removeItem(x);
              return _context3.abrupt("return", true);
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", _context3.t0 instanceof DOMException && (
              // everything except Firefox
              _context3.t0.code === 22 ||
              // Firefox
              _context3.t0.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              _context3.t0.name === 'QuotaExceededError' ||
              // Firefox
              _context3.t0.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
              // acknowledge QuotaExceededError only if there's something already stored
              storage && storage.length !== 0);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 8]]);
      }))();
    },
    storeToken: function storeToken(token) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this3.storageAvailable('localStorage')) {
                console.log('storing token');
                localStorage.setItem('security', token);
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    encryptDetailsForTransit: function encryptDetailsForTransit(email, passwordIncoming) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var password, intransitPassword, intransitEmail;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              password = passwordIncoming + '!!!!@!!!!';
              intransitPassword = CryptoJS.AES.encrypt(password, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              intransitEmail = CryptoJS.AES.encrypt(email, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              return _context5.abrupt("return", {
                intransitEmail: intransitEmail,
                intransitPassword: intransitPassword
              });
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    validateEmailFormat: function validateEmailFormat() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var email, emailRegex;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              email = _this4.email;
              emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(email)) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return", true);
            case 6:
              return _context6.abrupt("return", false);
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    register: function register() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // remove these   
              _this5.$store.commit('startIntroPage', 'UserLoginBlue');
              _this5.$store.commit('updateNewUserDetected', true);

              // this.$store.dispatch("registerActionEvent", {
              //     action: "prelogin",
              //     data: 'Trying to register',
              // });
              // var errorMessage = ''

              // if (this.firstname.length < 3) {
              //     this.firstnameError = '* Required';

              //     errorMessage = 'Please enter a first name';
              // } else if (this.firstname.length > 25) {
              //     this.firstnameError = '(name is too long)';
              //     errorMessage = 'Please check first name';
              // } else {
              //     this.firstnameError = null;
              // }
              // if (this.email.length < 4 || !await this.validateEmailFormat()) {
              //     this.emailError = '* Required';

              //     if (errorMessage.length > 0) {
              //         errorMessage += ', enter valid email address';
              //     } else {
              //         errorMessage = 'Please enter a valid email address';
              //     }
              // } else {
              //     this.emailError = null;
              // }
              // if (this.password.length < 8) {
              //     this.passwordError = '* Required';
              //     if (errorMessage.length > 0) {
              //         errorMessage += ' and a valid password';
              //     } else {
              //         errorMessage = 'Please enter a valid password';
              //     }
              // } else {
              //     this.passwordError = null;
              // }
              // if (errorMessage.length > 0) {
              //     this.message = errorMessage;
              //     return;
              // }
              // this.showLoader = true;
              // this.message = '';

              // let email = this.email;
              // this.$store.commit('updateUserEmail', email);

              // let encryptedData = await this.encryptDetailsForTransit(this.email, this.password);
              // console.log('intransitEmail', encryptedData.intransitEmail)
              // console.log('intransitPassword', encryptedData.intransitPassword)

              // var billingPlatform = 'web';
              // if (process.env.VUE_APP_ANDROID) {
              //     billingPlatform = 'android';
              // }
              // const data = {
              //     'password': encryptedData.intransitPassword,
              //     'email': encryptedData.intransitEmail,
              //     'billingPlatform': billingPlatform,
              //     'firstname': this.firstname,
              //     'lastname': this.lastname,
              //     // 'subscriptionType': this.$store.state.subscriptionType
              // };

              // // get current domain with http
              // // var domain = window.location.href.split('/').slice(0, 3).join('/');

              // var config = {
              //     method: 'post',
              //     url: `${this.$store.state.systemRoute}/registerAccount`,
              //     headers: {
              //         'Content-Type': 'application/x-www-form-urlencoded'
              //     },
              //     data: data
              // };

              // try {
              //     let response = await axios(config);
              //     console.log('response', response)
              //     this.showLoader = false;
              //     if (response && response.message) {
              //         this.message = response.message;
              //     }
              //     if (response && response.data && response.data.success && response.data.uid) {
              //         try {
              //             Window.fbq('track', 'Lead');
              //         }
              //         catch (error) {
              //             console.log('error in fbq track lead', error)
              //         }
              //         this.$store.dispatch("registerActionEvent", {
              //             action: "prelogin",
              //             data: 'registered',
              //         });
              //         this.$store.commit('updateUserUID', response.data.uid);
              //         // this.$store.dispatch('crazyEggUserLoggedIn');
              //         if (response.data.token) {
              //             this.storeToken(response.data.token);
              //             console.log('token should have been stored');
              //             this.$store.dispatch("registerActionEvent", {
              //                 action: "prelogin",
              //                 data: 'token provided',
              //             });
              //         }

              //         this.$store.commit('startIntroPage', 'UserLoginBlue');
              //         // this.$store.commit('updateShowExperienceSelector', true);
              //         // this.$store.commit("updateShowMainApplication", true);
              //         // this.$store.commit('updateNewUserDetected', true);

              //     }
              // }
              // catch (error) {

              //     console.log('error', error)
              //     this.$store.dispatch("registerActionEvent", {
              //         action: "prelogin",
              //         data: 'login error',
              //     });
              //     if (error && error.response && error.response.data) {
              //         if (error.response.data.message) {
              //             this.message = error.response.data.message;
              //         } else {
              //             this.message = 'Please check your details and try again.';
              //         }
              //         if (error.response.data.errorItems && Array.isArray(error.response.data.errorItems)) {
              //             let hasEmailIssue = false;
              //             // let hasFirstnameIssue=false;
              //             // let hasLastnameIssue=false;
              //             let hasPasswordIssue = false;
              //             error.response.data.errorItems.forEach((item) => {
              //                 if (item.issue === 'email') {
              //                     hasEmailIssue = true;
              //                     this.emailError = '* ' + item.message;
              //                 }
              //                 if (item.issue === 'password') {
              //                     hasPasswordIssue = true;
              //                     this.passwordError = '* ' + item.message;
              //                 }
              //                 // if(item.issue === 'firstname'){
              //                 //     hasFirstnameIssue=true;
              //                 //     this.firstnameError = '* ' + item.message;
              //                 // }
              //                 // if(item.issue === 'lastname'){
              //                 //     hasLastnameIssue=true;
              //                 //     this.lastnameError = '* ' + item.message;
              //                 // }
              //             })
              //             if (!hasEmailIssue) {
              //                 this.emailError = false;
              //             }
              //             if (!hasPasswordIssue) {
              //                 this.passwordError = false;
              //             }
              //             // if(!hasFirstnameIssue){
              //             //     this.firstnameError = false;
              //             // }
              //             // if(!hasLastnameIssue){
              //             //     this.lastnameError = false;
              //             // }

              //         }
              //     }
              //     this.showLoader = false;
              // }
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    }
  },
  setup: function setup() {},
  data: function data() {
    return {
      introSlides: [{
        image: "assets/web/allavatars.webp",
        topTitle: "Welcome & Thank You!",
        topSummary: "",
        header: "",
        description: "\n          <div style='text-align:left' class='writing'>\n            <div style=\"margin-top: 20px;\"></div>\n            I am so excited you've decided to try this app. \n          \n          <div style=\"margin-top: 10px;\"></div>\n          This has been in development for ..<i>awhile now</i>. I've actually been working on it for <b><i>over 14 months</i></b> working on it day and night...relentlessly.\n          <div style=\"margin-top: 10px;\"></div>\n          I've sacrificed time with my kids, friends and family, holidays and probably even promotions at work.\n          <div style=\"margin-top: 10px;\"></div>\n          I just knew I had to build this and bring it to the masses.\n\n          <div style=\"margin-top: 10px;\"></div>\n          It's not perfect just yet and there is <b><i>SO MUCH MORE coming!</i></b> But I think you'll enjoy it though and we can continue to grow with it together. <div class='yellow'>Running the app is not cheap. Currently this app is costing me over $20k a year to run <i><b>and climbing</b></i> so please support this app where you can or share it with the world.</div> \n          <img style='text-align:left;margin-top:-20px; height:100px;width:auto;position:absolute;right:-10%;z-index:99999;' src='assets/signature.webp' />\n       </div>\n           ",
        imageStyles: {
          height: "auto",
          width: "100%",
          "max-height": "180px",
          "object-fit": "cover"
        }
      }, {
        image: "assets/web/avatarSelector/mary.webp",
        topTitle: "The Goal",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  The goal of this app is to make  <b><i>the most realistic digital people imaginable</i></b> and provide a compelling, robust experience that caters to the needs of the user.\n           ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        }
      }, {
        image: "assets/web/avatarSelector/kurt.webp",
        topTitle: "Acknowledgement",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  While I've gone to great lengths making them as real as possible(still a work in progress though!). <span style=\"color:#a30202\"> Howerver, it's important that you understand that they <b><i>are not real people ...no matter what they tell you.</i></b> \n            </span>\n          <div style=\"margin-top: 20px;\"></div>\n          <div  class=\"yellow\">\n          Please understand that they <b><i>don't have a conscious</i></b>, nor are they <b><i>self aware</i></b> but they may seem really ..<b><i>really real</i></b> when you talk to them.\n          </div> ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        },
        nextButtonLabel: "Got it",
        nextButtonIcon: ["fa", "check"]
      }, {
        //     image: "assets/web/avatarSelector/mary.webp",
        //     topTitle: "So many possibilities",
        //     // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        //     header: "",
        //     description: `
        //   <div style='text-align:left; z-index:10;'>
        //     <div style="margin-top: 20px;"></div>
        //           Now, we can get onto the fun stuff. Please let us know your feedback on this intro and the app experience in general by joining our discord.
        //     </span>
        //   <div style="margin-top: 20px;"></div>
        //   <b><i>Okay, let's get past the terms and conditions and get started!</i></b>
        //    `,
        //     // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        //     imageStyles: {
        //       height: "500px",
        //       width: "auto",
        //       "max-height": "350px",

        //       // "object-fit": "cover",
        //     },
        hidePreviousButton: true,
        hideNextButton: true
      }],
      showPassword: false,
      showLoader: false,
      message: '',
      axios: axios,
      showLogin: false,
      showRegistration: true,
      showVerification: false,
      showRedirectToCheckout: false,
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordVerify: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      address1: '',
      address2: '',
      country: '',
      emailError: false,
      passwordError: false,
      firstnameError: false,
      lastnameError: false
    };
  }
};